
import React, { useState } from "react";
import { C } from "../utils/api";

export default function Login({login, loading, cfg}) {
  const [u,setU]=useState(""); const [p,setP]=useState(""); const [err,setErr]=useState("");
  const handle=async()=>{ const e=await login(u,p); if(e) setErr(e); };
  return (
    <div style={{minHeight:"100vh",background:C.primary,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"2rem"}}>
      <div style={{marginBottom:"2rem",textAlign:"center"}}>
        <img src="/logo512.png" style={{height:72,marginBottom:12}} alt="logo"/>
        <h1 style={{color:C.white,fontSize:24,fontWeight:700,margin:0}}>{cfg.nombre_empresa||"Time Telco"}</h1>
        <p style={{color:"#90CAF9",fontSize:13,margin:"4px 0 0"}}>Sistema FTTH</p>
      </div>
      <div style={{background:C.white,borderRadius:16,padding:"1.5rem",width:"100%",maxWidth:340}}>
        <label style={{fontSize:13,color:C.muted,display:"block",marginBottom:4}}>Usuario</label>
        <input value={u} onChange={e=>setU(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handle()} placeholder="usuario" style={{width:"100%",padding:"10px 14px",borderRadius:8,border:"1px solid "+C.border,fontSize:15,boxSizing:"border-box",marginBottom:12}}/>
        <label style={{fontSize:13,color:C.muted,display:"block",marginBottom:4}}>Contrasena</label>
        <input type="password" value={p} onChange={e=>setP(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handle()} placeholder="••••••••" style={{width:"100%",padding:"10px 14px",borderRadius:8,border:"1px solid "+C.border,fontSize:15,boxSizing:"border-box",marginBottom:16}}/>
        {err && <p style={{color:"#E53E3E",fontSize:13,margin:"0 0 12px"}}>{err}</p>}
        <button onClick={handle} disabled={loading} style={{width:"100%",padding:"12px 0",background:C.accent,color:C.white,border:"none",borderRadius:8,fontSize:15,fontWeight:600,cursor:"pointer"}}>{loading?"Ingresando...":"Ingresar"}</button>
      </div>
    </div>
  );
}
